export default function () {
    const checkToHasBlock = document.querySelector('.contact-us-btn')
    if (checkToHasBlock) {
        const openBtn = document.querySelector('.contact-us-btn .contact-us__wrapper');
        const closeBtn = document.querySelector('.contact-us-btn .contact-us__show .contact-us__show-close');
        const showBlock = document.querySelector('.contact-us-btn .contact-us__show');

        openBtn.addEventListener('click', function () {
            showBlock.classList.add("contact-us__show_active")
        });

        closeBtn.addEventListener('click', function () {
            showBlock.classList.remove("contact-us__show_active");
        });
    }
}
